import { render, staticRenderFns } from "./layoutEditorTwo.vue?vue&type=template&id=3c9954ba&scoped=true&"
import script from "./layoutEditorTwo.vue?vue&type=script&lang=js&"
export * from "./layoutEditorTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9954ba",
  null
  
)

export default component.exports